import how_to_get_card_img_01 from '../img/common/how_to_get_card_img_01.png';
import how_to_get_card_img_02 from '../img/common/how_to_get_card_img_02.png';
import how_to_get_card_img_03 from '../img/common/how_to_get_card_img_03.png';

export const howToGetCardItems = [
    {
        img: how_to_get_card_img_01,
        title: 'CARDS_COMMON_NEW_HOW_TO_GET_CARD_TITLE_01',
        text: 'CARDS_COMMON_NEW_HOW_TO_GET_CARD_TEXT_01'
    },
    {
        img: how_to_get_card_img_02,
        title: 'CARDS_COMMON_NEW_HOW_TO_GET_CARD_TITLE_02',
        text: 'CARDS_COMMON_NEW_HOW_TO_GET_CARD_TEXT_02'
    },
    {
        img: how_to_get_card_img_03,
        title: 'CARDS_COMMON_NEW_HOW_TO_GET_CARD_TITLE_03',
        text: 'CARDS_COMMON_NEW_HOW_TO_GET_CARD_TEXT_03'
    }
];
